export default {
    UserDetail: {
        PhoneNumberOrEmail: "Phone number/email",
        Email: "Email",
        PhoneNumber: "Phone number",
        LastName: "First name",
        FirstName: "Name",
        Role: "Roles",
        Admin: "Admin",
        User: "User",
        Position: "Title",
        Cancel: "Cancel",
        Save: "Save",
        AddUser: "Add user",
        EditUser: "Edit user",
        BatchAssignPermission: "Assign user permissions",
        ViewUserList: "View list",
        UsersSelected: count => `${count} user${count > 1 ? 's' : ''} selected.`,
        titleConfirmMisaID:
            "has been used by the user below. Is this the user you want to add?",
        Accept: "Add",
        Ignore: "Skip",
        EditRole: "Assign user's permissions",
        OrganizationUnit: "Unit",
        Edit: "Edit",
        MessageForAdmin: "<b>Admin</b> Allowed to access to all companies and users",
        MessageForUser: "<b>User</b> Are only allowed to access to the authorized unit",
        CanWorkingWith: "Have the permissions to work with",
        ErrorMiniumOrganization: "Please select at least 1 work unit.",
        RolePermission: "Roles & permissions",
        DivideRoleByUnit: "Assign permissions by unit",
        AllUnit: "All units",
        UnitName: "Unit name",
        EmaiTakeInvoice: "Invoice receiving email",
        NoDataSearchUnit: "No units found matching the search criteria, please try again",
        DidNotSettingWorkingUnit: "You haven't set up a work unit yet.",
        ExistEmailOrPhoneByOther: "Email or phone number that was used by another user. Please check it again.",
        FullName: "Full name",
        PleaseSelectRole: "Please select a role",
        RequireAtLeastOneUser: "Please select at least 1 user before proceeding with permission assignment.",
        BackToUserList: "Back to list",
        BatchAssignSuccess: count => `Successfully assigned permissions to ${count} user${count > 1 ? 's' : ''}.`,
        BatchAssignPartialSuccess: (success, failed) => `Successfully assigned permissions to ${success} user${success > 1 ? 's' : ''}, failed ${failed} user${failed > 1 ? 's' : ''}.`,
        BatchAssignFailed: 'Permission assignment failed. Please try again.',
        BatchAssignError: 'An error occurred during batch update. Please try again.',
        TextLogWorkingDividePermission: {
            FirstText: "Assign permissions by user",
            SecondText: "work with",
            ThirdText: "Tax Code",
            EndText: "Invoice receiving email",
        },
        TextLogDestroyPermission: {
            FirstText: "Assign permissions by user",
            SecondText: "work with",
            ThirdText: "Tax Code",
            EndText: "Invoice receiving email",
        },
    },
    UserList: {
        UserManager: "User management",
        ListUserLogin: "List of MISA mTax login users",
        AddUser: "Add user",
        ConfirmWhenDelete: (value) => `This user will no longer be able to work with tax code ${value}. Are you sure you want to delete?`,
        ConfirmWhenActive: (value) => `Enabled users will be allowed to work with tax code ${value}`,
        ConfirmWhenInActive: (value) => `Deactivated users will not be allowed to work with tax code ${value} until enabled again`,
        Active: "Active",
        Deactivate: "Deactivate",
        Decentralization: "Separate user permissions",
        DecentralizedUse: "Separate permissions",
        SearchPlaceHolder: "Enter your full name, email, phone number to search",
        AlertUserWillDelete:
            "The user will be deleted on the system and can not access MISA meInvoice.",
        DeleteUser: "Delete user",
        DeleteUserV2: 'Do you want to delete the user',
        AlertNeedOneAdminition: "Must have at least 1 admin account",

        // Bulk action
        UserSelected: count => `${count} user${count > 1 ? 's' : ''}`,
        UserListSelected: 'Selected user list',
        TotalUser: 'Total users',
        AssignPermission: 'Assign permissions',
        WarningReplacePermission: 'The selected list contains users who have been assigned permissions, this selection will replace the old permissions. Do you want to continue?',
        AssignPermissionComingSoon: 'Bulk permission assignment feature is under development.',
        CannotAssignPermissionToYourself: 'You cannot assign permissions to yourself. Please select other users.',
        NoDataSearch: 'No users found matching the search criteria, please try again'
    },
    DeleteUser: {
        Agree: "Agree",
        Cancel: "Cancel",
        Success: "Deleted user successfully",
        ContentWarringDelete: value => `This user will not be allowed to continue working with tax code <strong> ${value}.</strong>Are you sure you want to delete?`,
    },
    AddPermission: "Add a new title",
    Description: "Description",
    AddAccess: "Add successfully",
    ExistPermission: "The title name has already existed",
    StopUse: "Discontinued use",
    EditSuccess: "Edit successfully",
};
